import {
   userCodeService,
   userCodeValid,
   userLoginStartService,
   userLogoutService,
   userRegister,
   userRegisteredService,
   verifyTokenService,
} from "../../services/userService";
import { successMessage } from "../../utils/message";
import {
   userLogout,
   verifyTokenEnd,
   verifyUserPhone,
   userLoginFailure,
   verifyUserCode,
   registered,
   verifyUserRegistered,
   verifyUserLogin,
   verifyTokenStarted,
} from "./user";
import { showErrorMessage } from "../../services/httpService";

export const verifyTokenAsync = (silentAuth = false) => async (dispatch) => {
   await dispatch(verifyTokenStarted(silentAuth));

   const result = await verifyTokenService();
   if (result.error) {
      dispatch(verifyTokenEnd());
      showErrorMessage(result);
   }
   if (result.status) {
      if (result.status === 204) {
         dispatch(verifyTokenEnd());
         dispatch(userLogout());
      } else {
         dispatch(verifyUserPhone(result.data));
      }
   }
};

export const userRegisterPhone = (phone, token) => async (dispatch) => {
   const result = await userCodeService(phone, token);
   if (result.error) {
      showErrorMessage(result);
      dispatch(userLoginFailure());
   } else {
      return result;
   }
};

export const userRegistered = (number, token) => async (dispatch) => {
   const result = await userRegisteredService(number, token);

   if (result.error) {
      dispatch(userLoginFailure());
      return { status: false };
   } else {
      dispatch(verifyUserRegistered());
      return { status: true };
   }
};

export const userLoginStart = (phone, pass, token) => async (dispatch) => {
   const result = await userLoginStartService(phone, pass, token);
   if (result.error) {
      showErrorMessage(result);
      dispatch(userLoginFailure());
      return false;
   } else {
      dispatch(verifyUserLogin(result.data));
      return true;
   }
};

export const userRegisterCode = (phone, code, token, tokenCode) => async (dispatch) => {
   const result = await userCodeValid(phone, code, token, tokenCode);
   if (result.error) {
      showErrorMessage(result);
      dispatch(userLoginFailure());
   } else {
      await dispatch(verifyUserCode(result));
      return true;
   }
};

export const userRegisterComplete = (
   phone,
   address,
   postalCode,
   nationalId,
   cityId,
   password,
   fullname,
   tokenCode,
   codeMessage,
   legal,
   token
) =>
   async (dispatch) => {
      const result = await userRegister(
         phone,
         address,
         postalCode,
         nationalId,
         cityId,
         password,
         fullname,
         tokenCode,
         codeMessage,
         legal,
         token
      );
      if (result.error) {
         showErrorMessage(result);
         dispatch(userLoginFailure());
         return false;
      } else {
         successMessage("ثبت نام با موفقیت انجام شد");
         dispatch(registered(result.data));
         return true;
      }
   };

export const userLogoutAsync = () => async (dispatch) => {
   const res = await userLogoutService();
   if (res.error) {
      showErrorMessage(res);
      return false;
   } else {
      dispatch(userLogout());
      return true;
   }
};
